import * as React from 'react';

function SvgCarretArrowLeft(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.863 20.747a.587.587 0 01-.012.767.453.453 0 01-.689-.013l-5.025-5.793a.588.588 0 010-.755l5.025-5.787a.453.453 0 01.69-.013.587.587 0 01.011.767l-4.698 5.411 4.698 5.416z"
        fill={props.fill || '#414B56'}
      />
    </svg>
  );
}

export default SvgCarretArrowLeft;
